import React from 'react';
import { Crown, Zap, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const UpgradePrompt = ({ 
  isVisible, 
  onClose, 
  title = "Unlock AI Features", 
  description = "Get unlimited access to Lexi, our AI assistant, with EDX Red Pro.",
  compact = false 
}) => {
  if (!isVisible) return null;

  if (compact) {
    // Compact banner version
    return (
      <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-3 relative">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Crown className="w-5 h-5 text-yellow-300" />
            <div>
              <span className="font-medium">Upgrade to Pro for AI features</span>
              <span className="text-purple-100 ml-2">Only $1.99/month</span>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Link
              to="/subscription"
              className="bg-white text-purple-600 px-4 py-1 rounded-full text-sm font-medium hover:bg-purple-50 transition-colors"
            >
              Upgrade Now
            </Link>
            {onClose && (
              <button
                onClick={onClose}
                className="text-purple-100 hover:text-white transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Full modal version
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6 relative">
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X className="w-5 h-5" />
          </button>
        )}
        
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Crown className="w-8 h-8 text-purple-600" />
          </div>
          
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">{title}</h3>
          <p className="text-gray-600 dark:text-gray-300 mb-6">{description}</p>
          
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-center mb-3">
              <Zap className="w-5 h-5 text-yellow-500 mr-2" />
              <span className="font-semibold text-purple-800 dark:text-purple-300">Pro Features</span>
            </div>
            <ul className="text-sm text-purple-700 dark:text-purple-300 space-y-2">
              <li className="flex items-center">
                <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                All Basic features
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                Unlimited AI chat with Lexi
              </li>
            </ul>
            
            <div className="mt-4 text-center">
              <span className="text-2xl font-bold text-purple-800 dark:text-purple-300">$1.99</span>
              <span className="text-purple-600 dark:text-purple-400">/month</span>
            </div>
          </div>
          
          <div className="space-y-3">
            <Link
              to="/subscription"
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-3 px-4 rounded-lg font-medium transition-colors flex items-center justify-center"
            >
              <Crown className="w-4 h-4 mr-2" />
              Upgrade to Pro
            </Link>
            
            {onClose && (
              <button
                onClick={onClose}
                className="w-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 py-3 px-4 rounded-lg font-medium transition-colors"
              >
                Maybe Later
              </button>
            )}
          </div>
          
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-4">
            Cancel anytime • Secure payment by Stripe
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;